import { IKnm248 } from 'APIPackage/KnmModule/interfaces/IKnm248';
import { IDictionaryCheckListVersionManually } from 'APIPackage/KnmModule/interfaces/IDictionaryCheckListVersionManually';
import { deleteObjectProperties } from 'CorePackage/MainModule/common/deleteObjectProperties';

import { NEW_CHECKLIST_SELECT_OPTION_CODE } from '../constants/newChecklistSelectOption';
import { IKnmErknmForm } from '../interfaces/IKnmErknmForm';

export const convertManuallyChecklistsFormValueToKnmData = (values: IKnmErknmForm): IKnm248['manuallyCheckList'] => {
  const { knoOrganizationErknm, kindControl, checklistsErknm } = values;

  if (!checklistsErknm) {
    return null;
  }
  const checklistsFiltered = checklistsErknm.filter(
    item => (!item.checkList || item.checkList.code === NEW_CHECKLIST_SELECT_OPTION_CODE) && item.newTitle,
  );

  return checklistsFiltered.map(checklist => ({
    uuidOrganization: knoOrganizationErknm?.value.dictVersionId || null,
    uuidSupervision: kindControl?.value.dictVersionId || null,
    value: {
      id: null,
      code: null,
      title: checklist.newTitle || null,
      questions:
        checklist.questions?.map(question => ({
          id: question.id || null,
          code: question.code,
          title: question.title || null,
        })) || null,
    },
    answers:
      checklist.questions?.reduce((filteredAnswers: IDictionaryCheckListVersionManually['answers'], question) => {
        let newFilteredAnswers = filteredAnswers ? [...filteredAnswers] : null;

        if (question.answer) {
          if (!filteredAnswers) {
            newFilteredAnswers = [];
          }
          newFilteredAnswers?.push({
            codeQuestion: question.code,
            answerType: question.answer.answerType
              ? deleteObjectProperties(question.answer.answerType, ['label', 'value'])
              : null,
            noteAnswer: question.answer.noteAnswer || null,
            guid: question.answer.guid || null,
            dateCreate: question.answer.dateCreate || null,
          });
        }

        return newFilteredAnswers;
      }, null) || null,
    used: null,
    uploadedViaSmev: checklist.uploadedViaSmev || null,
    ervkCheckList: checklist.ervkCheckList || null,
  }));
};
